/*
 * ANIVERSARIO LE SENSIER — confete + barra de progresso do carrinho + desconto automatico no checkout.
 * Vanilla, sem dependencias. Carregado so quando a campanha esta ativa (snippets/aniversario-assets.liquid).
 * Respeita prefers-reduced-motion (sem confete) e window.LS_ANIV.confetti (liga/desliga no editor).
 */
(function () {
  'use strict';
  var cfg = window.LS_ANIV || {};
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COLORS = ['#ffffff', '#ffffff', '#e8eff7', '#c9d7e6', '#9db8d6', '#6f98c4', '#3f6fa8'];
  var LIGHT = { '#ffffff': 1, '#e8eff7': 1 }; // claros ganham contorno fino para aparecer sobre fundo branco

  function store(k, v) {
    try { if (v === undefined) return window.sessionStorage.getItem(k); window.sessionStorage.setItem(k, v); } catch (_) { return null; }
  }

  /* ---------------- confete (canvas) ---------------- */
  var canvas = null, ctx = null, parts = [], raf = 0, dpr = 1;

  function ensureCanvas() {
    if (canvas) return;
    canvas = document.createElement('canvas');
    canvas.className = 'aniv-confetti-canvas';
    canvas.setAttribute('aria-hidden', 'true');
    document.body.appendChild(canvas);
    ctx = canvas.getContext('2d');
    resize();
    window.addEventListener('resize', resize);
  }
  function resize() {
    if (!canvas) return;
    dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas.width = Math.floor(window.innerWidth * dpr);
    canvas.height = Math.floor(window.innerHeight * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  function teardown() {
    cancelAnimationFrame(raf); raf = 0; last = 0;
    window.removeEventListener('resize', resize);
    if (canvas && canvas.parentNode) canvas.parentNode.removeChild(canvas);
    canvas = ctx = null;
  }
  var last = 0, deadline = 0;
  function tick(ts) {
    if (!canvas) return;
    // independente de taxa de quadros (60/120Hz) e com prazo maximo (abas lentas/economia de energia)
    var dt = last ? Math.min((ts - last) / 16.667, 3) : 1; last = ts;
    if (performance.now() > deadline) parts.length = 0;
    ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
    var drag = Math.pow(0.985, dt);
    for (var i = parts.length - 1; i >= 0; i--) {
      var p = parts[i];
      p.vx *= drag; p.vy = p.vy * drag + 0.22 * dt;
      p.x += p.vx * dt; p.y += p.vy * dt; p.rot += p.vr * dt; p.tilt += 0.12 * dt; p.life += dt;
      var fade = p.life > p.max - 30 ? Math.max(0, (p.max - p.life) / 30) : 1;
      if (p.life >= p.max || p.y > window.innerHeight + 40) { parts.splice(i, 1); continue; }
      ctx.save();
      ctx.globalAlpha = fade;
      ctx.translate(p.x, p.y);
      ctx.rotate(p.rot);
      ctx.fillStyle = p.color;
      if (LIGHT[p.color]) { ctx.strokeStyle = 'rgba(63, 111, 168, .55)'; ctx.lineWidth = 1; }
      if (p.circle) { ctx.beginPath(); ctx.arc(0, 0, p.size / 2, 0, Math.PI * 2); ctx.fill(); if (LIGHT[p.color]) ctx.stroke(); }
      else { ctx.scale(1, Math.cos(p.tilt)); ctx.fillRect(-p.size / 2, -p.size / 3, p.size, p.size * 0.66); if (LIGHT[p.color]) ctx.strokeRect(-p.size / 2, -p.size / 3, p.size, p.size * 0.66); }
      ctx.restore();
    }
    if (parts.length) raf = requestAnimationFrame(tick); else { last = 0; teardown(); }
  }
  /** opts: x, y (px na viewport), count, angle (rad; PI/2 = para baixo), spread (rad), power */
  function burst(opts) {
    if (reduce || cfg.confetti === false) return;
    opts = opts || {};
    ensureCanvas();
    var n = opts.count || 90, angle = opts.angle != null ? opts.angle : -Math.PI / 2, spread = opts.spread || Math.PI * 0.9, power = opts.power || 1;
    for (var i = 0; i < n; i++) {
      var a = angle + (Math.random() - 0.5) * spread, s = (4 + Math.random() * 8) * power;
      parts.push({
        x: opts.x, y: opts.y, vx: Math.cos(a) * s, vy: Math.sin(a) * s,
        size: 6 + Math.random() * 6, rot: Math.random() * 6.28, vr: (Math.random() - 0.5) * 0.35, tilt: Math.random() * 6.28,
        color: COLORS[(Math.random() * COLORS.length) | 0], circle: Math.random() < 0.28, life: 0, max: 110 + Math.random() * 70
      });
    }
    deadline = performance.now() + 6500;
    if (!raf) raf = requestAnimationFrame(tick);
  }
  function burstFrom(el, opts) {
    if (!el || !el.getBoundingClientRect) return;
    var r = el.getBoundingClientRect();
    if (!r.width && !r.height) return;
    opts = opts || {};
    opts.x = opts.x != null ? opts.x : r.left + r.width / 2;
    opts.y = opts.y != null ? opts.y : r.top + r.height / 2;
    burst(opts);
  }
  window.LSConfetti = { burst: burst, burstFrom: burstFrom };

  /* ---------------- desconto automatico no checkout (a Yampi aceita ?promocode=CODIGO; o cliente nunca digita nada) ---------------- */
  // Chamado por snippets/yampi-checkout-redirect.liquid e YampiSnippet.liquid antes de redirecionar. Seguro por padrao:
  // so adiciona o desconto se a campanha esta ativa (este arquivo so carrega assim), o total >= minimo e a URL ainda nao tiver promocode.
  window.LS_ANIV_APPLY = function (url, totalCents) {
    if (!cfg.apply || !cfg.code || !cfg.minCents || typeof url !== 'string') return url;
    if (typeof totalCents !== 'number' || totalCents < cfg.minCents) return url;
    if (/[?&]promocode=/.test(url)) return url;
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'promocode=' + encodeURIComponent(cfg.code);
  };

  /* ---------------- clique no slide da barra = chuva de confete ---------------- */
  document.addEventListener('click', function (e) {
    var slide = e.target.closest && e.target.closest('[data-aniv-slide]');
    if (slide) burstFrom(slide, { count: 70, angle: Math.PI / 2, spread: Math.PI * 0.95, power: 0.9 });
  });

  /* ---------------- confete ao entrar no site (1x por sessao) ---------------- */
  function welcome() {
    if (reduce || cfg.confetti === false || store('aniv:welcome')) return;
    store('aniv:welcome', '1');
    setTimeout(function () {
      var w = window.innerWidth;
      [0.2, 0.5, 0.8].forEach(function (f) {
        burst({ x: w * f, y: 0, count: 45, angle: Math.PI / 2, spread: Math.PI * 0.9, power: 1.1 });
      });
    }, 500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', welcome); else welcome();

  /* ---------------- faixa do carrinho: anima o progresso; confete SO quando completa os R$499 (abrir o carrinho nao solta mais, 13/10) ---------------- */
  class AnivCartBar extends HTMLElement {
    connectedCallback() {
      var fill = this.querySelector('.aniv-cart__fill');
      var target = parseInt(this.getAttribute('data-pct'), 10) || 0;
      var prev = store('aniv:pct');
      if (fill && prev !== null && String(prev) !== String(target)) {
        fill.style.setProperty('--aniv-pct', prev + '%');
        void fill.offsetWidth;
        requestAnimationFrame(function () { fill.style.setProperty('--aniv-pct', target + '%'); });
      }
      store('aniv:pct', String(target));
      // meta completada agora (abaixo -> atingida): confete grande
      var reached = this.getAttribute('data-reached') === 'true';
      var was = store('aniv:reached');
      store('aniv:reached', reached ? '1' : '0');
      if (reached && was === '0') {
        var self = this;
        setTimeout(function () {
          if (!self.isConnected || !self.getClientRects().length) return;
          var r = self.getBoundingClientRect();
          burst({ x: r.left + r.width / 2, y: r.top + r.height / 2, count: 170, angle: Math.PI / 2, spread: Math.PI * 1.6, power: 1.5 });
        }, 350);
      }
    }
  }
  if (!window.customElements.get('aniversario-cart-bar')) window.customElements.define('aniversario-cart-bar', AnivCartBar);

  /* ---------------- faixa rosa do sorteio: entra de baixo p/ cima e sai de cima p/ baixo (o tema recria o carrinho a cada mudanca) ---------------- */
  var SORT_EASE = 'cubic-bezier(.65, 0, .35, 1)', SORT_MS = 900, sortPrev;
  function sortAnim(el, enter) {
    var bar = el.querySelector('.sorteio-bar'), txt = bar && bar.querySelector('span');
    if (!bar || reduce || !el.animate) return;
    var o = { duration: SORT_MS, easing: SORT_EASE };
    el.animate({ gridTemplateRows: enter ? ['0fr', '1fr'] : ['1fr', '0fr'] }, o);
    bar.animate({ clipPath: enter ? ['inset(100% 0 0 0)', 'inset(0 0 0 0)'] : ['inset(0 0 0 0)', 'inset(100% 0 0 0)'] }, o);
    var bag = el.querySelector('.sorteio-bag__art');
    if (bag) bag.animate({ transform: enter ? ['translateY(101%)', 'translateY(0)'] : ['translateY(0)', 'translateY(101%)'] },
      enter ? { duration: 900, delay: 250, easing: 'cubic-bezier(.22, 1, .36, 1)', fill: 'backwards' } : { duration: 500, easing: 'cubic-bezier(.55, 0, .75, .2)' });
    if (txt) txt.animate({ opacity: enter ? [0, 1] : [1, 0] }, enter ? { duration: 500, delay: 400, easing: 'ease-out', fill: 'backwards' } : { duration: 300, easing: 'ease-in' });
  }
  class AnivSorteio extends HTMLElement {
    connectedCallback() {
      var on = this.getAttribute('data-on') === 'true', prev = sortPrev;
      sortPrev = on;
      if (on && prev !== true) sortAnim(this, true);
      else if (!on && prev === true) sortAnim(this, false);
    }
  }
  if (!window.customElements.get('aniv-sorteio')) window.customElements.define('aniv-sorteio', AnivSorteio);
  // ao abrir o carrinho com a faixa ligada, ela entra de novo
  function watchSorteioOpen() {
    var d = document.querySelector('cart-drawer');
    if (!d || d.__sortWatched) return;
    d.__sortWatched = true;
    new MutationObserver(function () {
      if (!d.hasAttribute('open')) return;
      setTimeout(function () { var el = d.querySelector('aniv-sorteio[data-on="true"]'); if (el) sortAnim(el, true); }, 250);
    }).observe(d, { attributes: true, attributeFilter: ['open'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchSorteioOpen); else watchSorteioOpen();
  /* ---------------- cor da barra de anuncio acompanha o banner do slideshow ---------------- */
  function toneFor(slide) {
    var img = slide.querySelector('img'), s = (img && (img.currentSrc || img.src)) || '';
    if (slide.querySelector('video-media, video')) return 'linges';
    if (/ecobag/i.test(s)) return 'pink';
    if (/les-thes/i.test(s)) return 'dark';
    return 'blue';
  }
  function syncBarTone() {
    var bar = document.querySelector('.announcement-bar.aniv-bar');
    var sel = document.querySelector('[id*="slideshow"] .is-selected');
    if (!bar) return;
    bar.setAttribute('data-aniv-tone', sel ? toneFor(sel) : 'blue');
  }
  function watchSlideshow() {
    var sec = document.querySelector('[id*="slideshow"]');
    if (!sec) return;
    syncBarTone();
    new MutationObserver(syncBarTone).observe(sec, { attributes: true, attributeFilter: ['class'], subtree: true });
    sec.addEventListener('load', syncBarTone, true);   // imagem carregou: currentSrc passa a existir
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchSlideshow); else watchSlideshow();
})();
